export * from './tagState/tagState.component';
export * from './shewhartState/shewhartState.component';
export * from './tagsStatistics/tagsStatisticsState/tagsStatisticsState.component';